<template>
  <NuxtLayout
    name="generic"
    :header="data?.header"
    :footer="data?.footer"
  >
    <div v-if="data">
      <HeroContent
        v-if="data.heroContent"
        v-bind="data.heroContent"
        :title="data.title"
      />
      <SectionBuilder
        v-if="data.content"
        v-bind="data.content"
        :class="{
          'text-www-color-neutral-medium-dark': true,
        }"
      />

      <CtaBannerComponent
        v-if="data.CTABanner?.reference"
        :data="data.CTABanner.reference"
      />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { GenericQueryResult } from '~/sanity/types';

import CtaBannerComponent from '~/components/Organisms/CTABanner/CTABanner.vue';
import { genericQuery } from '~/queries/pages/PageGeneric.query';

const { path: currentPathname } = useRoute();
const { data } = await useWwwSanityQuery<GenericQueryResult>(genericQuery, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage: data.value?.ogImage ?? data.value?.cardImage,
  title: data.value?.htmlTitle || data.value?.title,
  twitterCard: 'summary',
});
</script>
